import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

interface FilterProps {
  competitionId: string
  competitionTitle?: string
  isSelected: boolean
  onFilterChange: (filter: string) => void
}

const FilterItem = styled(PrimaryCTAButton)`
  ${({
    theme: {
      spacing: { spacing40 },
    },
  }) => css`
    height: ${spacing40};
    cursor: pointer;
    white-space: nowrap;
  `}
`

const Filter: FunctionComponent<FilterProps> = ({
  competitionId,
  competitionTitle,
  onFilterChange,
  isSelected,
}) => {
  if (!competitionTitle) {
    return null
  }

  return (
    <FilterItem
      colorVariant={isSelected ? 'black' : 'grey'}
      onClick={() => onFilterChange(competitionId)}
    >
      {competitionTitle}
    </FilterItem>
  )
}

export default Filter
